module.exports = __webpack_public_path__ + "static/img/tuuci_classic.6675eb5.png";